export default "__VITE_ASSET__BDpUz$VS__"